import { request } from '../api';
import { TQuest, useQuestsStore } from '../stores';
import { storeDidCatch } from '../utils';

export const getDailyQuests = async () => {
  const { setQuests } = useQuestsStore.getState();

  try {
    const { data: { data: { quests } = {} } = {} } =
      await request.get('/quests');

    setQuests(quests);
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [getDailyQuests]', error);
  }
};

export const claimDailyQuests = async (questName: TQuest['name']) => {
  try {
    await request.post(`/quests/complete`, {
      name: questName,
    });
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [claimDailyQuests]', error);
  }
};
